import React from 'react';
import './style.scss';
import CardsListCardHeader from '../../cardParts/header';
import CardsListCardDescription from '../../cardParts/description';
import CardsListCardFooter from '../../cardParts/footer';
import CardsListCardRewardsButton from '../../cardParts/rewards/button';
import CardsListCardRewardsContent from '../../cardParts/rewards/content';
import CardsListCardSelector from '../../cardParts/selector';
import clsx from 'clsx';

const CardsListListCardCarousel = ({
  data,
  onSelect,
  isSelected,
  selectable,
  rewardsOpened,
  openRewards,
  dontShowCompare,
  t,
  contentItemRef,
}) => {
  const {
    image,
    heading,
    text,
    hyperLink,
    featuresList,
    cashBackOffer,
    infoHyperLink,
    discountIconsList,
    discountVoucher,
    slideSectionLabel1,
    slideSectionLabel2,
    slideSectionIcons,
    slideSectionDescription,
  } = data.fields;

  const shouldRenderRewards =
    !!slideSectionLabel1?.value ||
    !!slideSectionLabel2?.value ||
    !!slideSectionDescription?.value ||
    !!slideSectionIcons?.length > 0;

  return (
    <div className="cards-list-list-card" ref={contentItemRef}>
      <div className="cards-list-list-card-content">
        {(selectable || isSelected) && dontShowCompare !== '1' && (
          <CardsListCardSelector
            t={t}
            isSelected={isSelected}
            onClick={onSelect}
            className={clsx('cllc-selector-desktop', isSelected && 'cllc-selector-active')}
          />
        )}
        <div className="cllc-left">
          {(selectable || isSelected) && dontShowCompare !== '1' && (
            <CardsListCardSelector
              t={t}
              isSelected={isSelected}
              onClick={onSelect}
              className={clsx('cllc-selector-mobile', isSelected && 'cllc-selector-active')}
            />
          )}
          <CardsListCardHeader image={image} link={hyperLink} />
          <CardsListCardFooter
            heading={discountVoucher}
            icons={discountIconsList}
            className="cllc-footer-pc"
            onClick={openRewards}
          >
            {shouldRenderRewards && <CardsListCardRewardsButton opened={rewardsOpened} />}
          </CardsListCardFooter>
        </div>
        <CardsListCardDescription
          heading={heading}
          text={text}
          features={featuresList}
          offer={cashBackOffer}
          link={infoHyperLink}
          className="cllc-right"
          linkHover
        />
      </div>
      <CardsListCardFooter
        heading={discountVoucher}
        icons={discountIconsList}
        className="cllc-footer-mobile"
        onClick={openRewards}
      >
        {shouldRenderRewards && <CardsListCardRewardsButton opened={rewardsOpened} />}
      </CardsListCardFooter>
      {shouldRenderRewards && (
        <CardsListCardRewardsContent
          topHeading={slideSectionLabel1}
          bottomHeading={slideSectionLabel2}
          description={slideSectionDescription}
          iconsList={slideSectionIcons}
          opened={rewardsOpened}
        />
      )}
    </div>
  );
};

export default CardsListListCardCarousel;
